export default __webpack_public_path__ + "static/media/TM_Cutlery_Banner_New.aeab3471.jpg";